export const SUPPORTED_CHAINS = ["eth", "bsc", "polygon", "base"]